export default __webpack_public_path__ + "static/ak-cached/24h/media/cta-caret.58f28828.svg";